import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function Prize() {
    const { t } = useTranslation();
    const PrizeData = t("prize", { returnObjects: true });
    const locale = useSelector((state) => state.locale.locale);

    return (
        <div className="bg-black relative">
            <div className="flex mx-auto items-center justify-center z-10 min-h-screen md:pt-10 pt-24 bg-podiumMobile md:bg-podium bg-no-repeat bg-cover bg-center w-full bg-black">
                <div className="2xl:px-0 md:px-14 px-0 w-full py-4 pb-20">
                    <div className="w-full font-ronzino text-white">
                        <div className="container h-full mx-auto w-full">
                            <div className="w-full pt-10 md:pt-24 mb-10">
                                <div className={`container w-full mx-auto font-wantCoffee mb-12 ${locale === 'en' ? 'bg-textBgPodiumEn' : 'bg-textBgPodiumEn'} bg-no-repeat bg-left min-h-[180px] md:min-h-[240px] ${locale === 'en' ? 'bg-[length:400px_auto] md:bg-[length:540px_auto]' : 'bg-[length:400px_auto] md:bg-[length:540px_auto]'}`}>
                                    <p className={`text-6xl md:text-[5rem] relative top-8 md:top-10 leading-none text-secondary ${locale === 'en' ? 'left-12 md:left-16' : 'left-16'}`}>
                                        {locale === 'en' ? 'PRIZES' : 'HADIAH'}
                                    </p>
                                    <p className={`text-6xl md:text-[5rem] relative top-8 md:top-10 leading-none text-white ${locale === 'en' ? 'left-12 md:left-16' : 'left-16'}`} style={{ letterSpacing: '3px' }}>
                                        SUROBOYO10K
                                    </p>
                                </div>
                            </div>

                            <div className="flex flex-wrap items-stretch justify-center gap-4 md:gap-6 px-4 w-full">
                                {PrizeData.slice(0, 3).map((categoryData, idx) => (
                                    <div key={idx} className="flex flex-col bg-white max-w-[320px] w-full flex-auto min-w-[280px]">
                                        <div className="bg-primary text-secondary font-boldonse text-center py-6 px-4 flex flex-col justify-center items-center min-h-[100px]">
                                            <span className="text-xl md:text-2xl uppercase tracking-wider">{categoryData.category}</span>
                                            {categoryData.category !== 'KIDS DASH' && (
                                                <span className="text-lg md:text-xl uppercase tracking-wider mt-1">{t("home.prize.gender")}</span>
                                            )}
                                        </div>
                                        <div className="flex-1 py-8 px-4 font-roboto text-xl flex flex-col space-y-3">
                                            {categoryData.data.map((item) => (
                                                <div key={item.id} className="flex items-center justify-center gap-4 w-full">
                                                    <div className="text-secondary font-bold w-12 text-right">
                                                        {item.id}<sup className="font-medium text-sm">{item.id === 1 ? 'st' : item.id === 2 ? 'nd' : item.id === 3 ? 'rd' : 'th'}</sup>
                                                    </div>
                                                    <div className="text-mutedGrey font-medium w-28 text-left tracking-wide">
                                                        {new Intl.NumberFormat("id-ID").format(item.prize)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

